import { render, staticRenderFns } from "./batchReviewwResult.vue?vue&type=template&id=a3d0aa82&scoped=true"
import script from "./batchReviewwResult.vue?vue&type=script&lang=js"
export * from "./batchReviewwResult.vue?vue&type=script&lang=js"
import style0 from "./batchReviewwResult.vue?vue&type=style&index=0&id=a3d0aa82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d0aa82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d0aa82')) {
      api.createRecord('a3d0aa82', component.options)
    } else {
      api.reload('a3d0aa82', component.options)
    }
    module.hot.accept("./batchReviewwResult.vue?vue&type=template&id=a3d0aa82&scoped=true", function () {
      api.rerender('a3d0aa82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signatureVerification/component/batchReviewwResult.vue"
export default component.exports